import styled from 'styled-components'
import { customTheme } from '../../../styles/theme'

interface IVisibleElement {
  isShowing: boolean;
}

export const Overlay = styled.div`
position: absolute;
top: 0;
bottom: 0;
right: 0;
left: 0;
z-index: 99;

background: rgba(0, 0, 0, 0.55);
`

export const Wrapper = styled.div<IVisibleElement>`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 999999;

  display: ${({ isShowing }) => isShowing ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
`

export const Container = styled.div`
  width: 80%;
  height: 70vh;

  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  z-index: 9999;

  background: ${customTheme.colors.black};
  border-radius: 20px;
`

export const Content = styled.div`
  width: 100%;
  max-height: 85%;
  padding: 40px 20px 0px;
  
  overflow: hidden;

  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Image = styled.img`
  max-height: 85%;
  max-width: 80%;
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  position: absolute;
`

export const Button = styled.button`
  border: 50%;
  background: none;
  border: none;
  cursor: pointer;
`

export const CloseGallery = styled.button`
  position: absolute;
  top: 4.5%;
  right: 2%;
  z-index: 99;

  width: 50px;
  height: 50px;

  background: #FF4C61;
  border-radius: 63px;
  border: 14px solid #fff;
  cursor: pointer;
`

export const Footer = styled.div`
  width: 100%;
  height: 70px;
  position: absolute;
  bottom: 0;

  background-color: ${customTheme.colors.white};
  padding: 10px 15px;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
`

export const TeamName = styled.h4`
  margin-left: 15px;

  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  color: ${customTheme.colors.black};
`

export const Subtitle = styled.p`
  color: #000;
  margin: 0;
  font-size: 14px;
`

export const TeamArea = styled.div`
  display: flex;
`

export const SliderContent = styled.div`
  width: 100%;
  height: 70vh;

 .slick-slider,
 .slick-track {
    height: 100%;
  }
`

export const SliderItem = styled.div`
  position: relative;
  height: 70vh;
  
  img {
    width: calc(100% - 160px);
    object-fit: contain;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
  }
`

export const SliderControlsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
`
